import React from 'react';
import HeroSection from './HeroSection';
import ValuePropositionSection from '../MiningStocks/ValuePropositionSection';
import InvestmentSection from './InvestmentSection';
import HowWeHelpSection from './HowWeHelpSection';
import JoinTheClub from './JoinTheClub';
const TopMiningStocks: React.FC = () => {
    return (
        <div className="min-h-screen">
            <HeroSection />
            <ValuePropositionSection />
            <InvestmentSection />
            <HowWeHelpSection />
            <JoinTheClub />
        </div>
  );
};

export default TopMiningStocks;
